var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9794 2.96104C17.676 2.64935 17.2208 2.64935 16.9174 2.96104L16.3105 3.54545V0H0V20H16.3105V8.88312L19.4967 5.61039C19.6484 5.45455 19.7243 5.25974 19.7243 5.06493C19.7243 4.87013 19.6484 4.67532 19.4967 4.51948L17.9794 2.96104ZM14.7932 18.4416H1.51725V1.55844H14.7932V5.02597L8.57247 11.1429C8.49661 11.2208 8.42075 11.3377 8.38281 11.4156L7.24488 14.5325C7.13108 14.8442 7.20694 15.1558 7.43453 15.3896C7.66212 15.5844 8.0035 15.6623 8.26902 15.5065L11.3035 13.9481C11.3794 13.9091 11.4552 13.8701 11.4932 13.7922L14.7553 10.4416V18.4416H14.7932ZM9.938 12.9351L9.59662 12.5844L9.74834 12.1558L17.4484 4.5974L17.9036 5.06493L10.5449 12.6234L9.938 12.9351Z",
    fill: "#B5B5B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7239 0.389648H19.4205L17.5239 2.3377L20.1033 4.98705L21.9998 3.039V2.72731C21.9998 1.01303 20.6343 0.389648 19.7239 0.389648Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.19cb788ca7beabbe70b27687ee16c8c9.svg";
export { ForwardRef as ReactComponent };